
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { GateData, GateAnswer } from '@/types';
import { Weekday } from '@/enums';
import { getDanishWeekDays } from '@/utils';

@Component({})
export default class Gate extends Vue {
	@Prop() data!: GateData;
	@Prop() answer!: GateAnswer;

	private get days(): string[] {
		return getDanishWeekDays();
	}

	private toggleDay(day: string): void {
		if (this.answer.selectedDays.includes(day)) {
			const index: number = this.answer.selectedDays.indexOf(day);
			this.answer.selectedDays.splice(index, 1);
		} else {
			this.answer.selectedDays.push(day);
		}
	}

	private selectAllDays(): void {
		this.answer.selectedDays = Array.from(this.days);
	}

	private deselectAllDays(): void {
		this.answer.selectedDays = [];
	}
}
